
import axios from '@/utilities/axios-global'
// import hiaEventBus from '@/mixins/hiaEvent-Bus'

export function GET_DOCUMENTS(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/'
    if (payload.itemId) {
      url = url + 'list/' + payload.listId + '/item/' + payload.itemId + '/children'
    } else {
      url = url + 'list/' + payload.listId + '/children'
    }

    let postPayload = {
      accessToken: '',
      nextLink: payload.nextLink ? payload.nextLink : ''
    }

    axios.post(url, postPayload).then((response) => {
      if (payload.nextLink) {
        // need to add to existing document list
        context.commit('APPEND_DOCUMENTS', response.data.list)
      } else {
        // initial load - replace all
        context.commit('SET_DOCUMENTS', response.data.list)
      }
      context.commit('SET_NEXTLINK', response.data.nextLink)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function GET_ITEMID_FORLIST(context, listId) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/list/' + listId + '/item'
    let authInfo = {
      accessToken: ''
    }
    axios.post(url, authInfo).then((response) => {
      resolve(response.data)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function POST_FOLDER(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/list/' + payload.listId + '/item/' + payload.itemId + '/folder'
    let newFolder = {
      accessToken: '',
      folderName: payload.name
    }
    axios.post(url, newFolder).then((response) => {
      resolve(response.data)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function POST_FILE(context, payload) {
  return new Promise((resolve, reject) => {
    if (payload.attachment.size > 1073741824) {
      // eslint-disable-next-line
      reject({ response: { data: { message: 'Files size cannot be greater than 1 GB' } } })
      return
    }

    // we need to use a special endpoint and FormData here
    // to make the browser stream the file directly to the server instead
    // of storing it in local memory
    let formData = new FormData()
    formData.append('attachment', payload.attachment)
    formData.append('name', payload.name)
    formData.append('directory', payload.directory)
    formData.append('accessToken', '')

    let url = context.rootState.user.baseApiUrl + '/onedrive/list/' + payload.listId + '/item/' + payload.itemId + '/file'
    axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
      context.commit('PUSH_FILE', response.data)
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function DELETE_FILE(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/list/' + payload.listId + '/item/' + payload.itemId
    let deletePayload = {
      accessToken: ''
    }
    axios.delete(url, { data: { deletePayload } }).then((response) => {
      context.commit('REMOVE_FILE', payload.itemId)
      resolve()
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function RENAME_ITEM(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/list/' + payload.listId + '/item/' + payload.itemId + '/rename'
    let postPayload = {
      accessToken: '',
      newItemName: payload.newName
    }
    axios.post(url, postPayload).then((response) => {
      context.commit('REPLACE_FILE', response.data)
      resolve()
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function GET_FOLDERS(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/'
    if (payload.itemId) {
      url = url + 'list/' + payload.listId + '/item/' + payload.itemId + '/children/folders'
    } else {
      url = url + 'list/' + payload.listId + '/children/folders'
    }
    let postPayload = {
      accessToken: '',
      nextLink: payload.nextLink ? payload.nextLink : ''
    }
    axios.post(url, postPayload).then((response) => {
      if (payload.nextLink) {
        // need to add to existing document list
        context.commit('APPEND_FOLDERS', response.data.list)
      } else {
        // initial load - replace all
        context.commit('SET_CURRENTDIR', response.data.list)
      }
      context.commit('SET_FOLDEDRNEXTLINK', response.data.nextLink)
      resolve(true)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function MOVE_ITEM(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/list/' + payload.listId + '/item/' + payload.itemId + '/move'
    let postPayload = {
      accessToken: '',
      newParentId: context.state.selectedItemId
    }
    axios.post(url, postPayload).then((response) => {
      // context.commit('REPLACE_FILE', response.data)
      resolve()
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function MOVE_ITEM_PARTICLE(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/list/moveparticle'
    // let postPayload = {
    //   accessToken: '',
    //   newParentId: context.state.selectedItemId
    // }
    axios.post(url, payload, { onUploadProgress: payload.onUploadProgress }).then((response) => {
      // context.commit('REPLACE_FILE', response.data)
      resolve()
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export function GET_ITEM(context, payload) {
  return new Promise((resolve, reject) => {
    let url = context.rootState.user.baseApiUrl + '/onedrive/list/' + payload.listId + '/item/' + payload.itemId
    let postPayload = {
      accessToken: ''
    }
    axios.post(url, postPayload).then((response) => {
      let currItem = {
        itemId: response.data.id,
        id: response.data.id,
        name: response.data.name,
        webUrl: response.data.webUrl,
        folder: {
          childCount: response.data.folder ? response.data.folder.childCount : ''
        }
      }
      context.commit('SET_CURRENTITEM', currItem)
      resolve(currItem)
    }, (err) => {
      console.log(err)
      reject(err)
    })
  })
}

export default {
  GET_DOCUMENTS,
  POST_FOLDER,
  POST_FILE,
  DELETE_FILE,
  RENAME_ITEM,
  GET_ITEMID_FORLIST,
  GET_FOLDERS,
  MOVE_ITEM,
  GET_ITEM,
  MOVE_ITEM_PARTICLE
}
